import { useState } from "react";
import { colorAvatar, duracion, tamano, iniciales, horaCorta, urlThumb, partesConEnlaces } from "../../lib/telegram";

/** Avatar del chat: miniatura si la hay (nunca de un chat «Solo yo»), si no iniciales de color; candado si es «Solo yo». */
export function TgAvatar({ chat, owner, tam = 46 }) {
  const [fallo, setFallo] = useState(false);
  const estilo = { width: tam, height: tam, fontSize: Math.round(tam * 0.33) };
  if (chat.locked) return <span className="tg-av" style={{ ...estilo, background: "#8E6FD8" }} aria-hidden="true">🔒</span>;
  if (chat.has_thumb && !fallo) {
    // Una «foto» de 1 px (la miniatura simulada, o una rota) se vería como un círculo de un solo color: cae a iniciales.
    return <img className="tg-av" style={estilo} src={urlThumb(owner, chat.chat_id)} alt="" onError={() => setFallo(true)}
      onLoad={(e) => { if ((e.currentTarget.naturalWidth || 0) < 16 || (e.currentTarget.naturalHeight || 0) < 16) setFallo(true); }} />;
  }
  return <span className="tg-av" style={{ ...estilo, background: colorAvatar(chat.chat_id || chat.title) }} aria-hidden="true">{iniciales(chat.title)}</span>;
}

function Adjunto({ media }) {
  if (media.kind === "voice") {
    return (
      <div className="tg-vz" data-testid="tg-msg-voz" title="La reproducción de notas de voz aún no está disponible">
        <span aria-hidden="true">▶</span>
        <span className="tg-onda" aria-hidden="true">{[5, 11, 7, 13, 9, 14, 6, 12, 8, 10].map((h, i) => <i key={i} style={{ height: h }} />)}</span>
        <span>{duracion(media.duration)}</span>
        <span className="tg-nd">sin reproducción aún</span>
      </div>
    );
  }
  if (media.kind === "photo") return <div className="tg-adj" data-testid="tg-msg-foto">📷 Foto</div>;
  if (media.kind === "sticker") return <div className="tg-adj" data-testid="tg-msg-sticker">Sticker</div>;
  return <div className="tg-adj" data-testid="tg-msg-archivo">📎 {media.name || "Archivo"}{media.size ? ` · ${tamano(media.size)}` : ""}</div>;
}

/** Texto del mensaje con los enlaces http(s) en azul y clicables, como Telegram -- no se inventa nada más (sin menciones/formato). */
function TextoMensaje({ texto }) {
  const partes = partesConEnlaces(texto);
  return (
    <span className="tg-txt">
      {partes.map((p, i) => (p.tipo === "enlace"
        ? <a key={i} href={p.valor} target="_blank" rel="noopener noreferrer" className="tg-link">{p.valor}</a>
        : <span key={i}>{p.valor}</span>))}
    </span>
  );
}

/** Burbuja de un mensaje. Lo que sale de un empleado ya viene firmado «Nombre: …» desde el servidor: aquí se muestra tal cual. */
export default function TgMensaje({ m, grupo }) {
  const entrante = !m.out;
  return (
    <div className={`tg-bb ${entrante ? "i" : "o"}`} data-testid="tg-msg" data-out={m.out ? "1" : "0"}>
      {entrante && grupo && m.sender?.name && <span className="tg-n" style={{ color: colorAvatar(m.sender.id ?? m.sender.name) }}>{m.sender.name}</span>}
      {m.media && <Adjunto media={m.media} />}
      {m.text ? <TextoMensaje texto={m.text} /> : null}
      <div className="tg-tm">{horaCorta(m.ts)}{m.out ? <span className="tg-visto" aria-hidden="true"> ✓✓</span> : null}</div>
    </div>
  );
}
